export default {
  state: {},
  mutations: {

  },
  actions: {
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/modelManage.js